import { Phone } from "lucide-react";
import logo from "@/assets/oz-move-logo.webp";

const footerLinks = {
  Services: [
    { label: "Home Moves", href: "#services" },
    { label: "Apartment Moves", href: "#services" },
    { label: "Office Relocations", href: "#services" },
    { label: "Single Item Moves", href: "#services" },
    { label: "Same Day Moves", href: "#services" },
  ],
  Locations: [
    { label: "Sydney", href: "#quote" },
    { label: "Melbourne", href: "#quote" },
    { label: "Brisbane", href: "#quote" },
    { label: "Perth", href: "#quote" },
    { label: "Adelaide", href: "#quote" },
    { label: "Gold Coast", href: "#quote" },
  ],
  Company: [
    { label: "How It Works", href: "#how-it-works" },
    { label: "Reviews", href: "#reviews" },
    { label: "Get a Quote", href: "#quote" },
    { label: "Why Choose Us", href: "#comparison" },
    { label: "Contact", href: "#quote" },
  ],
  Legal: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms & Conditions", href: "#" },
  ],
};

const Footer = () => (
  <footer className="bg-[#111111] pt-14 pb-8">
    <div className="container">
      {/* Top row - logo, tagline, phone */}
      <div className="mb-10">
        <img src={logo} alt="OZ MOVE CO." className="h-28 md:h-32 w-auto mb-3" width="384" height="256" />
        <p className="text-[#FFC300] font-bold text-base">Fast. Reliable. Done Right.</p>
        <p className="text-white/60 text-xs mt-1.5">Fully insured&nbsp;•&nbsp;Fast response</p>

        <div className="mt-5">
          <p className="text-white/65 text-[11px] uppercase tracking-wider font-semibold mb-1.5">Call us</p>
          <a
            href="tel:1800556654"
            className="flex items-center gap-2 text-[#FFC300] font-bold text-xl hover:opacity-80 transition-opacity w-fit"
          >
            <Phone className="w-5 h-5" />
            1800 556 654
          </a>
        </div>
      </div>

      {/* Link columns */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-10">
        {Object.entries(footerLinks).map(([heading, links]) => (
          <div key={heading}>
            <p className="font-bold text-white text-sm mb-3.5">{heading}</p>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/45 text-sm hover:text-white/70 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Divider + copyright */}
      <div className="border-t border-white/10" />
      <div className="pt-5 text-white/60 text-xs text-center">
        © {new Date().getFullYear()} OZ MOVE CO. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
